/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckChecklistItemType } from './PaxCheckChecklistItemType';
import {
    PaxCheckChecklistItemTypeFromJSON,
    PaxCheckChecklistItemTypeFromJSONTyped,
    PaxCheckChecklistItemTypeToJSON,
    PaxCheckChecklistItemTypeToJSONTyped,
} from './PaxCheckChecklistItemType';
import type { PaxCheckChecklistItemStatus } from './PaxCheckChecklistItemStatus';
import {
    PaxCheckChecklistItemStatusFromJSON,
    PaxCheckChecklistItemStatusFromJSONTyped,
    PaxCheckChecklistItemStatusToJSON,
    PaxCheckChecklistItemStatusToJSONTyped,
} from './PaxCheckChecklistItemStatus';
import type { PaxCheckAllowedDocumentsSet } from './PaxCheckAllowedDocumentsSet';
import {
    PaxCheckAllowedDocumentsSetFromJSON,
    PaxCheckAllowedDocumentsSetFromJSONTyped,
    PaxCheckAllowedDocumentsSetToJSON,
    PaxCheckAllowedDocumentsSetToJSONTyped,
} from './PaxCheckAllowedDocumentsSet';
import type { PaxCheckChecklistItemRequirement } from './PaxCheckChecklistItemRequirement';
import {
    PaxCheckChecklistItemRequirementFromJSON,
    PaxCheckChecklistItemRequirementFromJSONTyped,
    PaxCheckChecklistItemRequirementToJSON,
    PaxCheckChecklistItemRequirementToJSONTyped,
} from './PaxCheckChecklistItemRequirement';
import type { PaxCheckRuleOrigin } from './PaxCheckRuleOrigin';
import {
    PaxCheckRuleOriginFromJSON,
    PaxCheckRuleOriginFromJSONTyped,
    PaxCheckRuleOriginToJSON,
    PaxCheckRuleOriginToJSONTyped,
} from './PaxCheckRuleOrigin';

/**
 * Document requirement with status and acceptable documents (and methods) to resolve it
 * @export
 * @interface PaxCheckDocumentRequirement
 */
export interface PaxCheckDocumentRequirement {
    /**
     * Checklist item id
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    id: string;
    /**
     * Title (localised)
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    title: string;
    /**
     * Short document title (localised)
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    shortTitle?: string | null;
    /**
     * Description (localised)
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    description?: string | null;
    /**
     * Short description (localised)
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    shortDescription?: string | null;
    /**
     * Any relevant requirements to present to passenger (eg hours to the onward flight for TICKET checklist item type)
     * @type {Array<PaxCheckChecklistItemRequirement>}
     * @memberof PaxCheckDocumentRequirement
     */
    requirements?: Array<PaxCheckChecklistItemRequirement> | null;
    /**
     * External link for more info
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    externalLink?: string | null;
    /**
     * 
     * @type {PaxCheckRuleOrigin}
     * @memberof PaxCheckDocumentRequirement
     */
    ruleOrigin: PaxCheckRuleOrigin;
    /**
     * 
     * @type {PaxCheckAllowedDocumentsSet}
     * @memberof PaxCheckDocumentRequirement
     */
    allowedDocumentsSet?: PaxCheckAllowedDocumentsSet;
    /**
     * 
     * @type {PaxCheckChecklistItemStatus}
     * @memberof PaxCheckDocumentRequirement
     */
    status: PaxCheckChecklistItemStatus;
    /**
     * 
     * @type {PaxCheckChecklistItemType}
     * @memberof PaxCheckDocumentRequirement
     */
    itemType: PaxCheckChecklistItemType;
    /**
     * Whether item is Travel Document requirement
     * @type {boolean}
     * @memberof PaxCheckDocumentRequirement
     */
    isTravelDocument: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckDocumentRequirement
     */
    type: string;
}



/**
 * Check if a given object implements the PaxCheckDocumentRequirement interface.
 */
export function instanceOfPaxCheckDocumentRequirement(value: object): value is PaxCheckDocumentRequirement {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('ruleOrigin' in value) || value['ruleOrigin'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('itemType' in value) || value['itemType'] === undefined) return false;
    if (!('isTravelDocument' in value) || value['isTravelDocument'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckDocumentRequirementFromJSON(json: any): PaxCheckDocumentRequirement {
    return PaxCheckDocumentRequirementFromJSONTyped(json, false);
}

export function PaxCheckDocumentRequirementFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckDocumentRequirement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'shortTitle': json['short_title'] == null ? undefined : json['short_title'],
        'description': json['description'] == null ? undefined : json['description'],
        'shortDescription': json['short_description'] == null ? undefined : json['short_description'],
        'requirements': json['requirements'] == null ? undefined : ((json['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementFromJSON)),
        'externalLink': json['external_link'] == null ? undefined : json['external_link'],
        'ruleOrigin': PaxCheckRuleOriginFromJSON(json['rule_origin']),
        'allowedDocumentsSet': json['allowed_documents_set'] == null ? undefined : PaxCheckAllowedDocumentsSetFromJSON(json['allowed_documents_set']),
        'status': PaxCheckChecklistItemStatusFromJSON(json['status']),
        'itemType': PaxCheckChecklistItemTypeFromJSON(json['item_type']),
        'isTravelDocument': json['is_travel_document'],
        'type': json['type'],
    };
}

export function PaxCheckDocumentRequirementToJSON(json: any): PaxCheckDocumentRequirement {
    return PaxCheckDocumentRequirementToJSONTyped(json, false);
}

export function PaxCheckDocumentRequirementToJSONTyped(value?: PaxCheckDocumentRequirement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'short_title': value['shortTitle'],
        'description': value['description'],
        'short_description': value['shortDescription'],
        'requirements': value['requirements'] == null ? undefined : ((value['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementToJSON)),
        'external_link': value['externalLink'],
        'rule_origin': PaxCheckRuleOriginToJSON(value['ruleOrigin']),
        'allowed_documents_set': PaxCheckAllowedDocumentsSetToJSON(value['allowedDocumentsSet']),
        'status': PaxCheckChecklistItemStatusToJSON(value['status']),
        'item_type': PaxCheckChecklistItemTypeToJSON(value['itemType']),
        'is_travel_document': value['isTravelDocument'],
        'type': value['type'],
    };
}

